export type MaveTag = 'mave-player' | 'mave-clip';

export type MaveType = 'player' | 'clip';

export type MaveQuality = 'sd' | 'hd' | 'fhd' | 'qhd' | 'uhd';

export function maveTagFromType(type: MaveType): MaveTag {
  return type === 'clip' ? 'mave-clip' : 'mave-player';
}

export function maveThumbnailUrl(embedId: string, spaceSubdomainPrefix: string): string {
  const path = embedId.startsWith(spaceSubdomainPrefix)
    ? embedId.slice(spaceSubdomainPrefix.length)
    : embedId;

  return `https://space-${spaceSubdomainPrefix}.video-dns.com/${path}/thumbnail.jpg`;
}
